import React from 'react';

interface ErrorBoxProps {
  warning?: string;
  onClick?: () => void;
}

export default function WarningBox({ warning, onClick }: ErrorBoxProps) {
  if (!warning) return null;

  return (
    <div className={`mb-2 text-center ${onClick ? 'cursor-pointer' : ''}`} onClick={e => (onClick ? onClick() : null)}>
      <p className='rounded-sm border-2 border-yellow-400 bg-yellow-100 py-1 text-sm text-yellow-500'>{warning}</p>
    </div>
  );
}
